// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__f0Js9","colMaxWidth":"Table_colMaxWidth__1zc0Y"};